var render, staticRenderFns
import script from "./SurveyFields.vue?vue&type=script&lang=ts&"
export * from "./SurveyFields.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyFields.vue?vue&type=style&index=0&id=3488a36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488a36a",
  null
  
)

export default component.exports